import { useTranslate } from "@similarweb/i18n-provider";
import { ArrowRight } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { IndustryTransition } from "../../types/impactReport";
import { industryTransitionKeys } from "../../utils/i18n";

import { IndustryValuesCell } from "./IndustryValuesCell";
import { MappingCard, MappingCardBody, MappingCardHighlighted } from "./styles";

type IndustryTransitionRowProps = {
    readonly transition: IndustryTransition;
    readonly rowIndex: number;
};

export const IndustryTransitionRow = ({ transition, rowIndex }: IndustryTransitionRowProps) => {
    const { translate } = useTranslate();
    const isUnmapped = transition.taxonomyPaths.length === 0;

    return (
        <Flex
            gap="12px"
            alignItems="stretch"
            data-automation={`industry-transition-impact-report-transition-row-${rowIndex}`}
        >
            <MappingCard flex="1">
                <MappingCardBody>
                    <IndustryValuesCell
                        values={[transition.industry]}
                        dataAutomation={`industry-transition-impact-report-row-current-${rowIndex}`}
                    />
                </MappingCardBody>
            </MappingCard>

            <Flex alignItems="center">
                <ArrowRight
                    size="sm"
                    color={colorsPalettes.carbon[300]}
                />
            </Flex>

            <MappingCardHighlighted flex="1">
                <MappingCardBody>
                    {isUnmapped ? (
                        <Text
                            fontVariant="body2"
                            color={colorsPalettes.carbon[400]}
                        >
                            {translate(industryTransitionKeys.reportRowUnmapped)}
                        </Text>
                    ) : (
                        <IndustryValuesCell
                            values={transition.taxonomyPaths}
                            dataAutomation={`industry-transition-impact-report-row-taxonomy-${rowIndex}`}
                        />
                    )}
                </MappingCardBody>
            </MappingCardHighlighted>
        </Flex>
    );
};
